import React, { useState, useEffect } from 'react'
import swal from 'sweetalert';
import axios from 'axios';
import $ from 'jquery';
import Moment from 'moment';
import jsPDF from 'jspdf';
import Select from 'react-select';
import html2pdf from 'html2pdf.js';
import Receipt from '../Receipt/Receipt';
import sign from '../../Assets/images/signature/sign.png';
import Royal_logo from '../../Assets/images/Royal-logo.svg';
import Notice from '../../Assets/images/Roya-Resort-Notice.png'

export default function AddPayment(props) {
    const [items, setitems] = useState({})
    const [payment, setpayment] = useState({ MethodId: "", BookingId: "", Payment: "", company_id: props.companyid });
    const [receviedamount, setreceviedamount] = useState({})
    const [bookingdetails, setbookingdetails] = useState({});
    const [addshift, setshift] = useState([])
    const [shiftvalue, setshiftvalue] = useState()
    const [mainimage, setmainimage] = useState([])
    const [isValid, setisValid] = useState(false);
    const [typevalue, settypevalue] = useState()
    const [stypevalue, setstypevalue] = useState()
    const [typevaluenew, settypevaluenew] = useState()
    const [sto, setsto] = useState()
    const [sfro, setsfro] = useState()
    const [isCheckedper, setIsCheckedper] = useState(false);
    const [isCheckedtrans, setIsCheckedtrans] = useState(false);
    const [isCheckedcroc, setIsCheckedcroc] = useState(false);
    const [isCheckedfood, setIsCheckedfood] = useState(false);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [type, settype] = useState([
        { label: "Cash", value: "1" },
        { label: "Bank", value: "2" },


    ])
    const [isCheckedmon, setIsCheckedmon] = useState(false);
    const [isCheckedtue, setIsCheckedtue] = useState(false);
    const [isCheckedwed, setIsCheckedwes] = useState(false);
    const [isCheckedsch, setIsCheckedsch] = useState(false);
    const [isCheckedfri, setIsCheckedfri] = useState(false);


    const [isCheckedclam, setIsCheckedclam] = useState(false);
    const [isCheckedgran, setIsCheckedgran] = useState(false);
    const [isCheckedsuper, setIsCheckedsuper] = useState(false);


    const [stype, setstype] = useState([
        { label: "Corporate", value: "1" },
        { label: "Family", value: "2" },
        { label: "Student", value: "3" },
        { label: "Edu. Institute", value: "3" },
        { label: "Friend", value: "5" }

    ])
    useEffect(() => {
    }, [])
    const setshiftvalues = (e) => {

    }
    const MainImageSelectHandler = (e) => {
        setmainimage({ files: e.target.files });
    }
    const settypevalues = (e) => {
        if (e.value == "2") {
            $('#log').hide();
        }
        else {
            $('#log').hide();
        }

        Unitamount(e.value)

    }
    async function Unitamount(shiftid) {

        const Uniturl = process.env.REACT_APP_APIURL + "payment/GetMethod?shiftid=" + shiftid + "&companyid=" + props.companyid;
        let Unitdata = await axios.get(Uniturl);
        var units = [];
        Unitdata.data.map((u) => {
            units.push({ value: u.id, label: u.title });
        })
        setshift(units);

        return ""
    }
    async function populatedata(id) {
        if (id.length == 0) {
            setitems({});
            // setpayment({...payment, Payment: "" });
            setreceviedamount({});
            setisValid(false)
            $('.customer_payment').slideUp();
            setisValid(false);
            $('#btnprint').hide()
            return;

        }
        const url = process.env.REACT_APP_APIURL + "Booking/GetALLBookingverify?bookingId=" + id + "&companyid=" + props.companyid;
        await fetch(url).then(res => res.json()).then(result => {

            if (result.status == 404) {
                // debugger;
                setitems({});
                // setpayment({...payment, Payment: "0" });
                setreceviedamount({});
                setisValid(false)
                $('.customer_payment').slideUp();
                $('#btnprint').hide();
            }
            else {

                paymentdata(id)
                $('.customer_payment').slideDown()
                setitems(result);
                setisValid(true);

                $('#btnprint').show()

            }

        }).catch((err) => {
            console.log(err);
        });
    }
    async function paymentdata(id) {
        const url = process.env.REACT_APP_APIURL + "payment/GetReceviedAmount?bookingid=" + id + "&companyid=" + props.companyid;
        await fetch(url).then(res => res.json()).then(result => {
            debugger;
            if (result.status == 404) {

            }
            else {
                setreceviedamount(result);
                // console.log(result)
            }

        }).catch((err) => {
            console.log(err);
        });
    }
    const refresh = () => {
        setitems({});
        setpayment({ MethodId: "", BookingId: "", Payment: "", company_id: props.companyid });
        setreceviedamount({});
        setisValid(false)
        $('.customer_payment').slideUp();
        $('#btnprint').hide()
        $('#log').hide()
    }
    const savemethod = async (data) => {
        const formData = new FormData();
        let f1 = document.getElementById("fileInputId1").value
        if (f1 === "") {
            await formData.append("MainimageUrl", null)
        }
        else {
            await formData.append("MainimageUrl", mainimage.files[0])
        }

        await formData.append("Company_id", payment.company_id);
        await formData.append("BookingId", payment.BookingId);
        await formData.append("Payment", payment.Payment);
        await formData.append("Method_ID", payment.MethodId);
        try {
            const res = await axios.post(process.env.REACT_APP_APIURL + "payment/AddPayment", formData,
                {
                    headers: {
                        'content-type': 'form-data'
                    }
                })
            if (res.status == 200) {

                debugger;
                swal({
                    title: "Saved Successfully",
                    //  text: "Once deleted, you will not be able to recover this imaginary file!",
                    icon: "success"
                })
                refresh();

            }
        }
        catch (ex) {
            console.log(ex)
            return 0;
        }
        //const url = process.env.REACT_APP_APIURL + "payment/AddPayment";
        //await fetch(url, {
        //    method: "POST",
        //    headers: {
        //        'Accept': "json",
        //        'Content-Type': 'application/json'
        //    },
        //    body: JSON.stringify(data)
        //}).then(res => {
        //    if (res.status == 200) {
        //        swal({
        //            title: "Saved Successfully",
        //            //  text: "Once deleted, you will not be able to recover this imaginary file!",
        //            icon: "success"
        //        })
        //        refresh();

        //    }
        //})
    }
    /* const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(isValid);
        if (isValid) {
            var remainingamount = (!isNaN(items.amount) ? items.amount : 0) - (!isNaN(receviedamount.payment) ? receviedamount.payment : 0)
            if (items.option2 == "2") {
                if (remainingamount == payment.Payment) {
                    savemethod(payment);
                }
                else {
                    return alert('You have to pay full remaining amount');
                }
            }
            else {
                if (payment.Payment > remainingamount) {
                    return alert('Receiving amount is greater then remaining amount')
                }
                else {
                    savemethod(payment);
                }
            }
            
        }
        else {
            alert('Booking id is not valid')
        }
    } */
    const handleSubmit = async (e) => {
        e.preventDefault();
        const submitButton = e.target.querySelector('button[type="submit"]');
        submitButton.disabled = true;
        submitButton.innerHTML = '<section><span class="loader-5"> </span></section>';

        try {
            //   console.log(isValid);
            if (isValid) {
                var remainingamount =
                    (!isNaN(items.amount) ? items.amount : 0) -
                    (!isNaN(receviedamount.payment) ? receviedamount.payment : 0);
                if (items.option2 === "2") {
                    if (remainingamount === payment.Payment) {
                        await savemethod(payment);
                    } else {
                        alert("You have to pay the full remaining amount");
                    }
                } else {
                    if (payment.Payment > remainingamount) {
                        alert("Receiving amount is greater than the remaining amount");
                    } else {
                        await savemethod(payment);
                    }
                }
            } else {
                alert("Booking ID is not valid");
            }
        } catch (error) {
            console.log(error);
            alert("An error occurred while saving: " + error);
        } finally {
            submitButton.disabled = false;
            submitButton.innerHTML = "Submit";
        }
    };
    /* test fucntion */
    var specialElementHandlers = {
        '#editor': function (element, renderer) {
            return true;
        }
    };

    function PrintElem(elem) {
        debugger;
        var remainingAmount = $('li').find('strong:contains("Remaining Amount")').next('span').text();
        //if (remainingAmount != 0) {
        //    swal(
        //        {
        //            icon: 'error',
        //            title: 'Download Gate Pass: Payment Required',
        //            text: "If you want to download the gate pass, you must first pay the full amount.!"
        //        })
        //}
        /*else {*/
        const url = process.env.REACT_APP_APIURL + "Booking/GetALLBooking?bookingId=" + items.bookingId + "&companyid=" + props.companyid;
        fetch(url).then(res => res.json()).then(result => {
            debugger;
            if (result.shiftId == 1037) {
                const newDate = Moment(new Date(result.bookingdate)).format('dddd');
                setsto("8:00 AM " + newDate);
                setsfro("6:00 PM " + newDate);
            }
            if (result.shiftId == 1038) {
                const newDate = Moment(new Date(result.bookingdate)).format('dddd');
                const newDate1 = Moment(new Date(result.bookingdate)).add(1, 'day').format('dddd');
                setsto("8:00 AM " + newDate);
                setsfro("6:00 AM " + newDate1);
            }
            if (result.shiftId == 1039) {
                const newDate = Moment(new Date(result.bookingdate)).format('dddd');
                const newDate1 = Moment(new Date(result.bookingdate)).add(1, 'day').format('dddd');
                setsto("8:00 PM " + newDate);
                setsfro("6:00 AM " + newDate1);
            }
            if (result.shiftId == 1040) {
                const newDate = Moment(new Date(result.bookingdate)).format('dddd');
                const newDate1 = Moment(new Date(result.bookingdate)).add(1, 'day').format('dddd');
                setsto("8:00 PM " + newDate);
                setsfro("6:00 PM " + newDate1);
            }
            if (result.unitId == 10) {
                setIsCheckedclam(true);
                setIsCheckedgran(false);
                setIsCheckedsuper(false);
            }
            if (result.unitId == 11) {
                setIsCheckedclam(false);
                setIsCheckedgran(true);
                setIsCheckedsuper(false);
            }
            if (result.unitId == 13) {
                setIsCheckedclam(false);
                setIsCheckedgran(false);
                setIsCheckedsuper(true);
            }
            if (result.type == "1") {
                setIsCheckedmon(true);
                setIsCheckedtue(false);
                setIsCheckedwes(false);
                setIsCheckedsch(false);
                setIsCheckedfri(false);

                setstypevalue("Corporate")
            }
            if (result.type == "2") {
                setIsCheckedmon(false);
                setIsCheckedtue(true);
                setIsCheckedwes(false);
                setIsCheckedsch(false);
                setIsCheckedfri(false);
                setstypevalue("Family")
            }
            if (result.type == "3") {
                setIsCheckedmon(false);
                setIsCheckedtue(false);
                setIsCheckedwes(true);
                setIsCheckedsch(false);
                setIsCheckedfri(false);
                setstypevalue("Edu. Institute")
            }
            if (result.type == "4") {
                setIsCheckedmon(false);
                setIsCheckedtue(false);
                setIsCheckedwes(false);
                setIsCheckedsch(true);
                setIsCheckedfri(false);
                setstypevalue("School")
            }
            if (result.type == "5") {
                setIsCheckedmon(false);
                setIsCheckedtue(false);
                setIsCheckedwes(false);
                setIsCheckedsch(false);
                setIsCheckedfri(true);
                setstypevalue("Friend")
            }
            if (result.status == 404) {
                swal(
                    {
                        icon: 'error',
                        title: 'Not found!',
                    })
            }
            else {
                $("#myModal").modal('show');
                setCurrentDate(new Date());
                setbookingdetails(result)
                paymentdata(items.bookingId)
                //console.log(result)
            }

        }).catch((err) => {
            console.log(err);
        });
        /* }*/

    }
    async function paymentdata(id) {
        const url = process.env.REACT_APP_APIURL + "payment/GetReceviedAmount?bookingid=" + id + "&companyid=" + props.companyid;
        await fetch(url).then(res => res.json()).then(result => {

            if (result.status == 404) {
                receviedamount.payment = 0
            }
            else {
                setreceviedamount(result);
            }

        }).catch((err) => {
            console.log(err);
        });
    }
    const gatePass = (e) => {
        e.preventDefault();
        let printEleme = document.getElementById('gatePas');
        var opt = {
            padding: [0, 0, 3, 0],
            filename: `Gatepass_${bookingdetails.bookingId}`,
            image: { type: 'jpeg', quality: 1 },
            html2canvas: {
                scale: 2,
                bottom: 20,

            },
            pagebreak: { mode: ['css'] },
            jsPDF: {
                unit: 'mm',
                orientation: 'portrait'
            }
        };
        setTimeout(() => {
            html2pdf().set(opt).from(printEleme).then(function () {
                $("#inner").css({ "font-size": "12px", "background-color": "#F5F5F5" });
            }).save();
        }, 300);
    }
    /* modal fadeout */
    const modelOut1 = (e) => {
        e.preventDefault();
        $("#myModal").modal('hide');
    }

    /* inline styling */
    const card = {
        marginBottom: '1.875rem',
        backgroundColor: '#fff',
        transition: 'all 0.5s ease-in-out',
        position: 'relative',
        border: '0rem solid transparent',
        borderRadius: '1.375rem',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        height: 'calc(100% - 1.875rem)',
    }
    const card_body = {
        padding: '0.5rem 2rem 0rem',
        flex: '1 1 auto',
    }
    const card_header = {
        borderColor: '#ffffff',
        position: 'relative',
        background: '#1d3641',
        padding: '1.5rem 1.875rem 1.25rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#002a73',
        borderRadius: '0 !important',
        backgroundColor: '#fff',
        paddingBottom: '0',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: '1.2rem',
    }
    const card_logo = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
    const img_logo = {
        width: '225px',
        height: '75px',

    }
    const re_heading = {
        marginTop: '0.5rem',
    }
    const d_grid = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    }
    const lineGrid = {
        disply: 'flex',
        marginBottom: '0.5rem',
    }
    const inLIne = {
        disply: 'flex',
        paddingRight: '0.6rem',
    }
    const pdRight = {
        paddingRight: '0.5rem',
    }
    const uLine = {
        fontWeight: '600',
        borderBottom: '1px solid gray',
        transform: 'translateY(-6px)',
        paddingLeft: '0.3rem',
        fontSize: '0.9rem',
    }
    const p_right = {
        paddingRight: '0.8rem',
    }
    const f_child = {
        paddingRight: '0.2rem',
        fontSize: '0.9rem',
    }
    const in_checkBox = {
        display: 'inline-flex',
        alignItems: 'center',
    }
    const in_label = {
        paddingRight: '0.2rem',
        margin: '0',
    }
    const in_checkbox = {
        height: '15px',
        width: '15px',
    }
    const center_text = {
        textAlign: 'center',
    }
    const fn_size = {
        fontSize: '0.8rem',
        marginBottom: '0',
    }
    const flx_main = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        width: '100%',
    }
    const col_5 = {
        display: 'flex',
        flex: "0 0 50%",
        maxWidth: "50%",
    }
    const col_4 = {
        display: 'flex',
        flex: '0 0 40%',
        maxWidth: '40%',
    }
    const col_6 = {
        display: 'flex',
        flex: '0 0 60%',
        maxWidth: '60%',
    }
    const col_7 = {
        display: 'flex',
        flex: '0 0 70%',
        maxWidth: '70%',
    }
    const col_8 = {
        flex: '0 0 80%',
        maxWidth: '80%'
    }
    const col_3 = {
        display: 'flex',
        flex: '0 0 30%',
        maxWidth: '30%',
    }
    const col_33 = {
        display: 'flex',
        flex: '0 0 33%',
        maxWidth: '33%',
    }
    const col_2 = {
        display: 'flex',
        flex: '0 0 20%',
        maxWidth: '20%',
    }
    const col_1 = {
        display: 'flex',
        flex: '0 0 10%',
        maxWidth: '10%',
    }
    const col_9 = {
        display: 'flex',
        flex: '0 0 90%',
        maxWidth: '90%',
    }
    const col_10 = {
        display: 'flex',
        flex: "0 0 100%",
        maxWidth: '100%',
    }
    const col_65 = {
        flex: '0 0 65%',
        maxWidth: '65%',
    }
    const col_25 = {
        flex: '0 0 25%',
        maxWidth: '25%',
    }
    const m_b1 = {
        marginBottom: '1rem',
    }
    const d_flex = {
        display: 'flex',
    }
    const under_line = {
        textDecoration: 'underline',
    }
    const ul_list = {
        marginBottom: '0.4rem',
        listStyle: 'auto',
    }
    const ul_sty = {
        paddingLeft: '1.5rem'
    }
    const mr_top3 = {
        marginTop: '3rem',
    }
    return (
        <div className="row">
            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-2 mt-5 text-center mx-auto">Add Payment</h3>
                    </div>
                    <div className="card-body">
                        <div className="basic-form">
                            <form onSubmit={handleSubmit}>

                                <div className="row flex-column align-items-center">
                                    <div className="mb-3 col-11 col-md-6">
                                        <label htmlFor="booking_id" className="form-label">Booking ID</label>
                                        <input type="number" autoComplete="off" required className="form-control" value={payment.BookingId} onChange={function (e) { populatedata(e.target.value); setpayment({ ...payment, BookingId: e.target.value }) }} />
                                    </div>
                                    <div className="mb-3 col-11 col-md-6">
                                        <label htmlFor="booking_id" className="form-label">Method</label>
                                        <Select value={typevalue} options={type} onChange={(e) => { settypevalues(e); setitems({ ...items, type: e.value }) }} />
                                    </div>
                                    <div className="mb-3 col-11 col-md-6">
                                        <label className="form-label">Title</label>
                                        <Select options={addshift} value={shiftvalue} id="title" onChange={(e) => { setshiftvalues(e); setpayment({ ...payment, MethodId: e.value }) }} />
                                    </div>
                                    <div className="mb-3 col-11 col-md-6" style={{ display: "none" }} id="log">
                                        <label htmlFor="unit_name" className="form-label">Attachment</label>
                                        <input className="form-control" id="fileInputId1" type="file" onChange={MainImageSelectHandler} accept="image/*" />
                                    </div>
                                    <div className="mb-5 col-11 col-md-6">
                                        <label htmlFor="booking_id" className="form-label">Pay Amount</label>
                                        <input type="number" autoComplete="off" required className="form-control" value={payment.Payment} onChange={(e) => { setpayment({ ...payment, Payment: e.target.value }) }} />
                                    </div>
                                </div>
                                <div className='d-flex justify-content-center'>
                                    <button type="submit" className="btn btn-primary pr-3 me-3 text-center">Save</button>
                                    <button className="btn btn-primary" id="btnprint" type="button" style={{ display: "none" }} onClick={() => { PrintElem("customer_payment") }}>Gate Pass</button>
                                </div>
                                <div className="row mt-4 customer_payment" style={{ display: "none" }}>
                                    <div className="mt-3 float-right">
                                    </div>
                                    <div id="customer_payment" className="row">
                                        <Receipt
                                            customerDetails={{
                                                name: items.cusName,
                                                email: items.email,
                                                phone: items.phone,
                                                bookingDate: Moment(items.bookingdate).format('MM/DD/yyyy'),
                                                unit: items.unitName,
                                                shift: items.shiftName,
                                            }}
                                            paymentDetails={{
                                                beforeDiscount: items.samount,
                                                discount: (isNaN(items.samount) ? 0 : items.samount) - (isNaN(items.damount) ? 0 : items.damount),
                                                totalAmount: items.damount,
                                                paidAmount: receviedamount.payment,
                                                remainingAmount: (isNaN(items.damount) ? 0 : items.damount) - (isNaN(receviedamount.payment) ? 0 : receviedamount.payment),
                                            }}
                                        />
                                    </div>
                                </div>


                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="editor">
            </div>
            <div id="myModal" className="modal fade " tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content" >

                        {/* gat pass card */}
                        <div className='card' id="gatePas">
                            <div className='card-header d-flex flex-column' >
                                <div style={card_logo}>
                                    <img style={img_logo} src={Royal_logo} alt="Royal-Logo" />
                                </div>
                                <h3>Gate Pass</h3>
                                <div className='download_button' id='repoPrint' data-html2canvas-ignore="true"><a onClick={gatePass} href="">Download</a><a onClick={modelOut1} href="">✕</a></div>
                            </div>
                            <div className='card-body'>
                                <div style={d_grid}>
                                    <div className="uper-rec">
                                        <span style={inLIne}><span style={f_child}>G/P#</span><span style={uLine}>{"S" + bookingdetails.bookingId}</span></span>
                                        <span style={inLIne}><span style={f_child}>Date#</span><span style={uLine}>{Moment(bookingdetails.entrydate).format('DD/MM/yyyy')}</span></span>
                                    </div>
                                    <div className="col-6 mx-auto">
                                        <div className="d-flex align-items-center justify-content-center">
                                            <span style={inLIne}><span style={in_checkBox}><label style={in_label} htmlFor="company">Clan</label><input style={in_checkbox} type="checkbox" id='clan' checked={isCheckedclam} /></span></span>
                                            <span style={inLIne}><span style={in_checkBox}><label style={in_label} htmlFor="family">Grand</label><input style={in_checkbox} type="checkbox" id='grand' checked={isCheckedgran} /></span></span>
                                            <span style={inLIne}><span style={in_checkBox}><label style={in_label} htmlFor="student">Supreme</label><input style={in_checkbox} type="checkbox" id='supreme' checked={isCheckedsuper} /></span></span>
                                        </div>
                                    </div>
                                    <p style={lineGrid} className='input-grup'>
                                        <span style={inLIne}><span style={f_child}>Booking Date:</span><span style={uLine}>{Moment(bookingdetails.bookingdate).format('DD/MM/yyyy')}</span></span>
                                        <span style={inLIne}><span style={f_child}>Farm#</span><span style={uLine}>{bookingdetails.unitName}</span></span>
                                        <span style={inLIne}><span style={in_checkBox}><label style={in_label} htmlFor="company">Company</label><input style={in_checkbox} type="checkbox" id='company' checked={isCheckedmon} /></span></span>
                                        <span style={inLIne}><span style={in_checkBox}><label style={in_label} htmlFor="family">Family</label><input style={in_checkbox} type="checkbox" id='family' checked={isCheckedtue} /></span></span>
                                        <span style={inLIne}><span style={in_checkBox}><label style={in_label} htmlFor="Edu. Institute">Edu. Institute</label><input style={in_checkbox} type="checkbox" id='Edu. Institute' checked={isCheckedwed} /></span></span>

                                        <span style={inLIne}><span style={in_checkBox}><label style={in_label} htmlFor="Friend">Friend</label><input style={in_checkbox} type="checkbox" id='Friend' checked={isCheckedfri} /></span></span>
                                    </p>
                                    <p style={{ ...lineGrid, ...center_text, ...flx_main }}>
                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm3 tm-md-1' style={{ ...f_child, ...col_5 }}>TImeSlot:(Day & Time)</span><span style={{ ...uLine, ...col_5 }}>{sto}</span></span>
                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm2-3 tm-md-2' style={{ ...f_child, ...col_4 }}>To(Day & Time)</span><span style={{ ...uLine, ...col_6 }}>{sfro}</span></span>
                                        <span style={col_10}><strong><p style={fn_size}>(22H Booking: Morning 8am to 6am or Night 8pm to 6pm next day & for 10H: Morning 8am to 6pm or Night 8pm to 6am)</p></strong> </span>
                                    </p>
                                    <p style={{ ...lineGrid, ...flx_main }}>
                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='col-md-5 gm-md-1' style={{ ...f_child, ...col_65 }}>No. of "Guests Allowed" (Max.)</span><span style={{ ...uLine, ...col_2 }}>{bookingdetails.noOfMembers}</span></span>
                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm1-8 ev-md-2' style={{ ...f_child, ...col_3 }}>Event Type:</span><span style={{ ...uLine, ...col_7 }}>{stypevalue}</span></span>
                                    </p>
                                    <p style={{ ...lineGrid, ...flx_main }}>
                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm2 cl-md-1' style={{ ...f_child, ...col_3 }}>Client Name:</span><span style={{ ...uLine, ...col_7 }}>{bookingdetails.cusName}</span></span>
                                        {/*                                         <span className='main-col-item m-b-1 ' style={{ ...inLIne, ...col_5 }}><span className='colsm2 cl-md-1' style={{ ...f_child, ...col_3 }}>Client CNIC:</span><span style={{ ...uLine, ...col_6 }}>xxxxx-xxxxxxx-x</span></span>
 */}                                        <span className='main-col-item m-b-1 cnicClint' style={{ ...inLIne, ...col_4 }}><span className='colsm2 cl-md-1' style={{ ...f_child, ...col_2 }}>Cell</span><span style={{ ...uLine, ...col_7 }}>{bookingdetails.phone ? bookingdetails.phone.replace(/(\d{4})(\d{7})/, '$1 $2') : 'N/A'}</span></span>
                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_6 }}><span className='colsm2 cl-md-1' style={{ ...f_child, ...col_3 }}>Total Amount:Rs. </span><span style={{ ...uLine, ...col_6 }}>{bookingdetails.amount}</span></span>
                                    </p>
                                    <p style={{ ...lineGrid, ...flx_main }}>
                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm2-5 tlt-md-1' style={{ ...f_child, ...col_6 }}>Amount Paid (Advance): Rs.</span><span style={{ ...uLine, ...col_3 }}>{receviedamount.payment}</span></span>
                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm4-3 paid-md-2' style={{ ...f_child, ...col_5 }}>Balance Amount: Rs.</span><span style={{ ...uLine, ...col_4 }}>{(isNaN(bookingdetails.amount) ? 0 : bookingdetails.amount) - (isNaN(receviedamount.payment) ? 0 : receviedamount.payment)}</span></span>
                                    </p>
                                    <p style={{ ...lineGrid, ...flx_main }}>
                                        <span className='main-col-item m-b-1 ful-width' style={{ ...inLIne, ...col_10, ...d_flex }}><span className='colsm3-5 adi-md-3' style={{ ...f_child, ...col_33 }}>Contact Person at Royal Resort:</span><span className='colsm6-5' style={{ ...uLine, ...col_6 }}>Cell# 03010881116</span></span>
                                    </p>
                                    <p style={{ ...lineGrid, ...flx_main }}>
                                        <span className='main-col-item m-b-1 ful-width' style={{ ...inLIne, ...col_10, ...d_flex }}><span className='colsm3-5 adi-md-1' style={{ ...f_child, ...col_25 }}>Note: </span><span className='colsm6-5' style={{ ...uLine, ...col_7 }}>{bookingdetails.note}</span></span>
                                    </p>
                                    <div className="sign">
                                        <span class="s-hidden"> <strong>Signature:</strong> </span>
                                        <img src={sign} alt="signature image" />
                                    </div>
                                </div>
                                {/* important notes */}
                                <div>
                                    <h5 className='mt-3'>TERMS & CONDITIONS:</h5>
                                    <p className="requirement"><strong>In Order to book a farm you have to fullfill following requirements</strong></p>
                                    <ul className='list-Style' style={ul_sty}>
                                        <li style={ul_list}>Read & accept complete "Booking Constract & Rules Regulations".(Constract attached)</li>
                                        <li style={ul_list}>In case of cancellation of event, amount deposited being forfeited(Booking amount is not refundable).</li>
                                        <li style={ul_list}>Maximum "Guests Allowed" would be followed strictly; else you will be required to pay Rs.1000 per person at the farm house entry.</li>
                                        <li style={ul_list}>Required Original CNIC and Security Deposit of Rs.15,000 at the time of check-in. It will be refundable in case of no breakage or loss during your event, otherwise damages will be charged accordingly.</li>
                                        <li style={ul_list}>Couples are not allowed without "Nikah Nama" or Proof of Relationship.</li>
                                        <li style={ul_list}>Use of drinks (alcohol), dance party, any indecent gathering, Loud Music, any kind of weapon, Fireworks, Shisha (Hukkah), Laser Lights, spitting, drone camera, Paan/Gutka, and any illegal activity etc. are strictly not allowed.</li>
                                        <li className='page-break-before' style={ul_list}>Check-in and check-out timings will be followed strictly, while swimming pool must be vacant one hour before check-out time for cleaning purpose.</li>
                                        <li style={ul_list}>Cold drinks in glass bottles or any kind of glass bottles are not allowed. You can purchase tea, snack, cold drinks, ice cream and water bottles etc. from the resort.</li>
                                        <li style={ul_list}>Sports Activities and other electrical appliances may be suspended due to weather or any other unforeseen reasons at any time.</li>
                                    </ul>
                                </div>
                                {/* footer signnature */}
                                <div className='html2pdf__page-break'>
                                    <div style={{ ...d_grid, ...mr_top3 }}>
                                        <p style={{ ...lineGrid, ...flx_main }}>
                                            <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5, ...d_flex }}><span style={{ ...f_child, ...7 }}>Date of issuing Receipt.</span><span style={{ ...uLine, ...col_3 }}>{Moment(currentDate).format('DD/MM/yyyy')}</span></span>
                                            <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_4, ...d_flex }}><span className='bk-md-1' style={{ ...f_child, ...col_3 }}>Booked By:</span><span style={{ ...uLine, ...col_6 }}>{bookingdetails.bookedby}</span></span>
                                            <span style={{ ...col_10, ...m_b1 }}><strong><p style={fn_size}></p></strong> </span>
                                        </p>
                                    </div>
                                </div>
                                <div className='my_updatepdf'>
                                    <img src={Notice} alt="notice_PDf" />
                                </div>
                            </div>
                        </div>
                        {/* gat pass card */}
                    </div>
                </div>
            </div>
        </div>


    )
}


